<template>
  <div class="edit-advice-tab-content">
    <h4>Gekoppelde polissen</h4>

    <a-table :columns="columns" :data-source="getPolicies" rowKey="id" :pagination="false">
      <span slot="connect" slot-scope="text, record">
        <a-switch
            @change="toggleConnect($event, record.unhashed_id)"
            :checked="mortgage.policies.includes(record.unhashed_id)"
            class="advice-connect-switch"
        ></a-switch>
      </span>
      <span slot="link" slot-scope="text, record">
        <a :href="getRoute(record)">{{ record.contract_number || "geen polisnummer" }}</a>
      </span>
      <span slot="mutation_code" slot-scope="text, record">
        <a-tag :color="record.status.color">{{ record.status.description }}</a-tag>
      </span>
      <span slot="description" slot-scope="text, record" v-html="sanitizeHTML(text)"/>
      <span slot="insured_amounts" slot-scope="text, record">{{ Object.values(text)[0] }}</span>
      <span slot="total_term_amount" slot-scope="text, record">{{ text | toCurrency }}</span>
    </a-table>
  </div>
</template>

<script>
import policyApi from "~/api/policy";
import { mapGetters } from "vuex";
import DOMPurify from "dompurify";

export default {
  name: "MortgageEditAdviceComponent",
  props: {
    customerId: Number
  },
  data() {
    return {
      policies: [],
      columns: [
        {
          title: "Koppelen",
          key: "connect",
          dataIndex: "connect",
          scopedSlots: { customRender: "connect" }
        },
        {
          title: "Polisnummer",
          key: "link",
          dataIndex: "link",
          scopedSlots: { customRender: "link" }
        },
        {
          title: "Mutatiecode",
          key: "mutation_code",
          dataIndex: "mutation_code",
          scopedSlots: { customRender: "mutation_code" }
        },
        {
          title: "Omschrijving",
          key: "description",
          dataIndex: "description",
          scopedSlots: { customRender: "description" }
        },
        {
          title: "Maatschappij",
          key: "agency",
          dataIndex: "agency"
        },
        {
          title: "Verzekerde som",
          key: "insured_amounts",
          dataIndex: "insured_amounts",
          scopedSlots: { customRender: "insured_amounts" }
        },
        {
          title: "Termijnbedrag",
          key: "total_term_amount",
          dataIndex: "total_term_amount",
          scopedSlots: { customRender: "total_term_amount" }
        },
      ]
    };
  },
  mounted() {
    this.fetchPoliciesByCustomer(this.customerId);
  },
  methods: {
    async fetchPoliciesByCustomer(customerId) {
      this.loading = true;
      try {
        let response = await policyApi.getByCustomerId(customerId, ["view_group"]);

        this.policies = response.data;
      } catch (e) {
        this.$notification["error"]({
          message: "Er is iets mis",
          description: "De polissen konden niet worden opgehaald."
        });
      } finally {
        this.loading = false;
      }
    },
    toggleConnect(toConnect, policyId) {
      if (!Array.isArray(this.mortgage.policies)) {
        this.mortgage.policies = [policyId];
        return;
      }

      if (this.mortgage.policies.includes(policyId)) {
        this.mortgage.policies.splice(this.mortgage.policies.indexOf(policyId), 1);
      } else {
        this.mortgage.policies.push(policyId);
      }
    },
    getRoute(policy) {
      try {
        return this.route(policy.is_package ? "vue.insurance.package" : "vue.insurance.policy", {
          customer: this.customerId,
          policy: policy.id,
          package: policy.is_package ? policy.id : null
        });
      } catch (e) {
        console.error(e);
      }
    },
    sanitizeHTML(html) {
      return DOMPurify.sanitize(html, {ADD_TAGS: ['kenteken']});
    }
  },
  computed: {
    getPolicies() {
      return this.policies.filter(policy => policy.hasOwnProperty("view_group") && policy.view_group?.data?.mortgage);
    },
    ...mapGetters({
      mortgage: "mortgage/mortgage"
    })
  }
};
</script>

<style scoped>

</style>
